import React from "react";
import Banner_AboutUs from "../components/body/aboutus/Banner_AboutUs";
import {
  Bannerdata,
  dataHeroSection,
  dataVision,
  dataServiceSection,
  dataServices,
  dataFounder
} from "./data";
import Navbar from "../components/Navbar/Navbar";
import Main_Footer from "../components/footer/IndiaFooter/Main_Footer";
import HeroSection from "../components/body/aboutus/HeroSection";
import Card_Mission from "../components/body/aboutus/Card_Mission";
import Card_Services from "../components/body/aboutus/Card_Services";
import Card_Leadership from "../components/body/aboutus/Card_Leadership";
const Aboutus = () => {
  return (
    <div>
      <Navbar />
      <Banner_AboutUs Bannerdata={Bannerdata} />
      <section>
        <Card_Leadership cardData={dataFounder}/>
      </section>
      {/* Section Vison & Mission  */}
      <section className=" py-14">
        <HeroSection dataHeroSection={dataHeroSection} />
        <Card_Mission cardData={dataVision} />
      </section>
      {/* Section Serivices */}
      <section className=" w-full bg-[#f1f1f2] py-5">
        <HeroSection dataHeroSection={dataServiceSection} />
        <Card_Services cardData={dataServices} />
      </section>
     
      <Main_Footer />
    </div>
  );
};

export default Aboutus;
